// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5642a0c","239":"d0c31c71","453":"6ed04c70","732":"6e2b6f31"}[chunkId] + ".chunk.js";
};